//React、hooks
import React, { useEffect, useState } from "react";
//css
import "../../css/PassChange.css";

import { useDispatch, useSelector } from "react-redux";
import {
  errorMsg,
  passChangeJudge,
  fetchAsyncPassChange,
} from "./PassChangeSlice";
import { useHistory } from "react-router-dom";

const PassChange: React.FC = () => {
  const [word, setWord] = useState("");
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  //エラーメッセージ
  const errorMessage = useSelector(errorMsg);
  //ログイン成功判定
  const passChangeJudgement = useSelector(passChangeJudge);
  //reducerにアクセス
  const dispatch = useDispatch();
  //リダイレクト用
  const navigate = useHistory();

  //ログイン成功？
  useEffect(() => {
    if (passChangeJudgement) {
      navigate.push("/login");
    }
  }, [passChangeJudgement, navigate]);

  //ログインフォーム送信関数
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    dispatch(
      fetchAsyncPassChange({ user_id: userId, password: password, word: word })
    );
  };
  return (
    <>
      <div className="login_container">
        <form className="login_form">
          <div className="login_title_container">
            <h1 className="login_title">Su__i 管理者画面　パスワード変更</h1>
          </div>

          <div className="login_input_container">
            {errorMessage && (
              <div className="error_msg">{errorMessage.toString()}</div>
            )}
            <input
              className="login_id_item"
              type="id"
              placeholder="user_id"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
            />
            <input
              className="login_password_item"
              type="password"
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <input
              className="login_word_item"
              type="text"
              placeholder="Word"
              value={word}
              onChange={(e) => setWord(e.target.value)}
            />
          </div>
          <div className="login_submit_button_container">
            <button className="login_submit_button" onClick={handleSubmit}>
              パスワード変更
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default PassChange;
